"use client";

import { io, type Socket } from "socket.io-client";

import { env } from "@/env";

type NotificationSocketEventMap = {
  "notification:new": (payload: unknown) => void;
  "notification:unread_count": (payload: unknown) => void;
  "notification:read_sync": (payload: unknown) => void;
};

export type NotificationsSocket = Socket<
  NotificationSocketEventMap,
  Record<string, never>
>;

function getSocketBaseUrl() {
  if (env.NEXT_PUBLIC_SOCKET_URL) {
    return env.NEXT_PUBLIC_SOCKET_URL.replace(/\/+$/, "");
  }

  return new URL(env.NEXT_PUBLIC_API_BASE_URL).origin;
}

function getSocketPath() {
  if (env.NEXT_PUBLIC_SOCKET_PATH) {
    return env.NEXT_PUBLIC_SOCKET_PATH.startsWith("/")
      ? env.NEXT_PUBLIC_SOCKET_PATH
      : `/${env.NEXT_PUBLIC_SOCKET_PATH}`;
  }

  return "/socket.io";
}

export function createNotificationsSocket(token: string): NotificationsSocket {
  return io(getSocketBaseUrl(), {
    autoConnect: false,
    path: getSocketPath(),
    transports: ["websocket", "polling"],
    reconnection: true,
    reconnectionAttempts: Infinity,
    reconnectionDelay: 1000,
    auth: {
      panel: "B2C",
      token,
    },
  });
}
